import React, { useState, useEffect } from "react";
import Header from "../../Components/header";
import Footer from "../../Components/footer";
import { useNavigate } from "react-router-dom";
import { getSessionOrder, confirmPayment } from '../../Services/Order'



const ThankYou = () => {
    const navigate = useNavigate();
    const [orderId, setOrderId] = useState('');
    const [invoice, setInvoice] = useState('');

    useEffect(() => {
        let sessionId = localStorage.getItem("stripeSessionId");
        let payload = {
            sessionId: sessionId
        }
        if (sessionId) {
            let order = getOrder(payload)
        } else {
            setOrderId(localStorage.getItem("orderId"))
            setInvoice(localStorage.getItem("invoiceId"))
            setTimeout(() => {
                localStorage.setItem("invoiceId", '');
                localStorage.setItem("orderId", '');
            }, 1000);



        }
    }, [])

    let getOrder = async (data) => {
        let response = await getSessionOrder(data)
        if (response.data && response.data.paymentSession) {
            setOrderId(response.data._id)
            setInvoice(response.data.invoice)
            let payload = {
                sessionId: response.data.paymentSession
            }
            let confirmData = await confirmPayment(payload)
            localStorage.setItem("stripeSessionId", '');
            console.log("confirmDat -->", confirmData.data)


        }

    }

    return (
        <>
            <div className="wrapper">
                <Header />
                <div className="page-tankyou-waper py-5">
                    <div className="container">
                        <div className="row">
                            <div className="col-12 col-md-6 m-auto">
                                <div className="thank-wap-main text-center">
                                    <h1 className="txt-heading-oder mb-4">Your order has been received</h1>

                                    <div className="icon-check-success"><i className="fal fa-check-circle"></i></div>
                                    <div className="py-4">
                                        <h3 className="txt-sub-heading-oder mb-4">Thank you for your purchase !</h3>
                                        <p class="mb-0">
                                            Your <b>order ID </b> is : {orderId}
                                        </p>
                                        <p class="mb-0">
                                            Your <b>Invoice ID</b>  is : {invoice}
                                        </p>
                                        <p class="mb-0">
                                            You can check your order details and invoice in your profile
                                        </p>
                                    </div>
                                    <div onClick={() => navigate("/profile")} className="button-order-txt"><button type="button" className="btn btn-order-btn">Go To Order</button> </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <Footer />
            </div>
        </>
    )
}
export default ThankYou;